var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71094 4.64924C4.78269 3.93009 5.03419 3.24054 5.44229 2.64408C5.8504 2.04762 6.40199 1.5634 7.04631 1.236C7.6906 0.9086 8.40689 0.74854 9.12934 0.770554C9.8517 0.792568 10.5569 0.995947 11.1801 1.36197C11.8033 1.728 12.3243 2.2449 12.6954 2.86512C13.0664 3.48532 13.2755 4.1889 13.3033 4.91108C13.3311 5.63326 13.1768 6.35084 12.8546 6.99776C12.5385 7.63252 12.0707 8.17923 11.4929 8.5896",
    stroke: "#F5F5F5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29883 2.90381C5.96558 3.59215 6.76396 4.13936 7.64647 4.51289C8.529 4.88642 9.47765 5.07865 10.436 5.07812C11.3785 5.07906 12.3116 4.89346 13.1817 4.53228",
    stroke: "#F5F5F5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07544 8.15527C7.83208 8.15527 7.59413 8.22745 7.39171 8.36271C7.18931 8.49793 7.03157 8.69017 6.93841 8.91507C6.84526 9.13989 6.82089 9.38735 6.86837 9.62611C6.91586 9.86487 7.03308 10.0842 7.2052 10.2563C7.37733 10.4284 7.59659 10.5456 7.83536 10.5931C8.07412 10.6406 8.32158 10.6162 8.54648 10.5231C8.77138 10.4299 8.96354 10.2722 9.09876 10.0698C9.23406 9.86742 9.30618 9.62939 9.30618 9.38603C9.30618 9.05964 9.17654 8.74654 8.94573 8.51573C8.71493 8.28494 8.40191 8.15527 8.07544 8.15527Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15234 6.04004V6.92454C3.15234 7.57736 3.41168 8.20346 3.8733 8.66507C4.33492 9.12668 4.961 9.38604 5.61383 9.38604H6.7816",
    stroke: "#F5F5F5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 19.2321C16.9999 17.7688 16.5982 16.3337 15.8386 15.0831C15.0821 13.8375 13.9995 12.8226 12.708 12.1479",
    stroke: "#F5F5F5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.2317C0.999836 17.7686 1.40127 16.3336 2.16055 15.0829C2.91604 13.8386 3.99697 12.8243 5.28654 12.1494",
    stroke: "#F5F5F5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveSupport);
export default __webpack_public_path__ + "static/media/live-support.9790a3aac05f6350ab3eeff02b3d5b5d.svg";
export { ForwardRef as ReactComponent };